import React, { useState, useEffect } from 'react';
import Utils from 'sccUtils';
import "../../styles/Legal.scss";


// GET legal.csv info from rt_auth.js
const getLegalListing = async () => {
  try {
    const options = {
      url: Utils.apiUrlPrefix + "/auth/legal",
      method: "GET",
    };
    const response = await Utils.httpRequestHandler(options);
    return response.data;
  } catch (error) {
    console.error('Error getLegalListing', error);
    throw error;
  }
};

const filterName = (input) => {
  const stringNoQuotes = input.replace(/["']/g, '');
  const newString = stringNoQuotes.replace(/^@/, '').replace(/s*@/, '').replace(/,$/, '').replace(/^\^/, '').replace(/\s*\^/, '');
  return newString;
}


const Legal = (props) => {
  const { translateLegal } = props;

  const [legalList, setLegalList] = useState([]);
  const [selectName, setSelectName] = useState(-1);

  useEffect(() => {
    const fetchData = async() => {
      try { 
        const result = await getLegalListing();
        setLegalList(result);
      } catch(error) {
        console.error('Error Legal useEffect', error);
      }
    };
    fetchData();
  }, []);


  const handleSelectNameClick = (index) => {
    if (selectName !== index) {
      setSelectName(index);
    } else {
      setSelectName(-1);
    }
    const rightColumn = document.getElementById('right-column');
    if (rightColumn) {
      rightColumn.scrollTop = 0;
    }
  };

  return (
    <div className="column-section">

      <div className="left-column">
        <div className="left-name">
          {legalList.map((obj, index) => (
            <div className="left-select-name" key={index} style={{ backgroundColor: selectName === index ? '#b4b4b4a1' : 'transparent' }}>
              <div onClick={() => {handleSelectNameClick(index)}}>
                {filterName(obj.Name)}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="right-column" id="right-column" style={{ overflowY: 'auto', height: '300px' }}>
        {selectName > -1 ? (
          <>
            <div className="right-header">
              <div className="right-name">
                {filterName(legalList[selectName].Name)}
              </div>
              <div className="right-version-license">
                {/* {filterName(legalList[selectName].License)} - {filterName(legalList[selectName].Version)} */}
                {filterName(legalList[selectName].License)}
              </div>
            </div>
            <div className='right-body'>
              <div className="right-description-main">
                <div className="right-description-header">
                  <strong>{translateLegal("Description")}:</strong>
                </div>
                <div className='right-description-body'>
                  {filterName(legalList[selectName].Description)}
                </div>
              </div>
              <div className="right-copyright-main">
                <div className="right-copyright-header">
                  <strong>{translateLegal("Copyright")} : </strong>
                </div>
                <div className='right-copyright-body' style={{ whiteSpace: 'pre-line' }}>
                  {filterName(legalList[selectName].Copyright)}
                </div>
              </div>
              <div className="right-link">
                <div>{translateLegal('For more info click')}
                  <a href={filterName(legalList[selectName].Link)} target="_blank" rel="noopener noreferrer"><strong> {translateLegal('here')}</strong></a>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="right-default-message">
            {translateLegal('Select an entry to the left to view more information.')}
          </div>)}
      </div>
    </div>
  );
};

export default Legal;